import { Component, OnInit } from '@angular/core';
import { LoaderService } from '../../services/loader.service';
import { NgOptimizedImage } from '@angular/common';
import { DomainEventBus, DomainEventType } from '../../events/domain-event-bus';
import { HeaderComponent } from '../header/header.component';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [NgOptimizedImage, HeaderComponent],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.less'
})
export class NotFoundComponent implements OnInit {
  constructor(
    private loader: LoaderService,
    private bus: DomainEventBus
  ) {}

  ngOnInit(): void {
    this.bus.emit({ type: DomainEventType.NotFoundPageShown, url: window?.location?.href } as any);
    setTimeout(() => {
      this.loader.hideLoader();
    });
  }
}
